import { render, staticRenderFns } from "./commit.vue?vue&type=template&id=69a3f47c"
import script from "./commit.vue?vue&type=script&lang=js"
export * from "./commit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports